/* ------------------------- External Dependencies -------------------------- */
import React from 'react'
/* ------------------------- Internal Dependencies -------------------------- */
import {BackgroundImage} from 'atomic'
import { FirestoreDocument } from 'containers'

/* ------------------------------- Component -------------------------------- */
export default props => <FirestoreDocument {...props}
collection="resources"
foundry={'ResourceProfileInterface'}
/>


// WEBPACK FOOTER //
// ./src/interface/foundry/Resource/ResourceFirestoreDocument/index.js